/**
 * トップページRecruitエリアの動画orスライドショー
 */

export default class recruitMovie {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'recruitMovie';
    this.isPC = Useragnt.pc;
    this.isPlay = false;
    this.counter = 0;
    this.time = 5.0;
    this.slideTimer = null;
    this.presentWidth = 0;

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    // dom
    const el = document.getElementById('js-recruit-ad');

    if (this.isPC) {
      el.querySelector('.p-ad-recruit__bg--sp').style.display = 'none';
    } else {
      el.querySelector('.p-ad-recruit__bg--pc').style.display = 'none';
    }

    this.setSrc();
  }

  /**
   * 読み込み
   */
  setSrc() {
    // dom
    const el = document.getElementById('js-recruit-ad');

    // URLをセット
    if (this.isPC) {
      // 背景は動画
      const bg = el.querySelector('.p-ad-recruit__bg--pc');
      /*
      this.video = bg.querySelector('video');

      this.video.addEventListener('canplay', function(){console.log('canplay event fired');});
      this.video.addEventListener('canplaythrough', function(){console.log('canplaythrough event fired');});

      this.video.setAttribute('src', this.video.getAttribute('data-src'));
      this.video.loop = true;
      this.video.muted = true;
      */

    } else {
      // 背景はスライドショー
      const bg = el.querySelector('.p-ad-recruit__bg--sp');
      this.slides = bg.querySelectorAll('li');
      this.slides.forEach((el, index) => {
        const ref = el.querySelector('img');
        ref.setAttribute('src', ref.getAttribute('data-src'));
        TweenMax.set(ref, {opacity: 0});
      });
    }
  }

  /**
   * スライド再生
   */
  slideStart() {
    TweenMax.fromTo(this.slides[this.counter].querySelector('img'), 0.7,{
      opacity: 0
    }, {
      opacity: 1,
      ease: Cubic.easeOut
    });

    // 表示
    this.slideTimer = TweenMax.fromTo(this.slides[this.counter].querySelector('img'), this.time,{
      scale: 1.2
    }, {
      scale: 1,
      onComplete: this.slideNext.bind(this)
    });

    //this.slideTimer = setTimeout(this.slideNext.bind(this), this.time);
  }

  /**
   * 次のスライド
   */
  slideNext() {
    let next = this.counter + 1;
    if (next >= this.slides.length) {
      next = 0;
    }

    // 消す
    TweenMax.to(this.slides[this.counter].querySelector('img'), 0.8,{
      opacity: 0,
      ease: Cubic.easeInOut
    });

    // 表示
    TweenMax.fromTo(this.slides[next].querySelector('img'), 0.7,{
      opacity: 0
    }, {
      delay: 0.3,
      opacity: 1,
      ease: Cubic.easeOut
    });

    // 表示
    this.slideTimer = TweenMax.fromTo(this.slides[next].querySelector('img'), this.time,{
      scale: 1.1
    }, {
      delay: 0.2,
      scale: 1,
      onComplete: this.slideNext.bind(this)
    });

    // 次のスライドタイマー
    this.counter = next;
    //this.slideTimer = setTimeout(this.slideNext.bind(this), this.time);
  }

  /**
   * 再生
   */
  play() {
    if (this.isPlay) return;
    this.isPlay = true;

    if (this.isPC) {
      // video再生
      //this.video.play();
    } else {
      // スライド再生
      this.slideStart();
    }
  }

  /**
   * 停止
   */
  pause() {
    this.isPlay = false;

    if (this.isPC) {
      // video停止
      //this.video.pause();
    } else {
      // スライド停止
      this.slideTimer.kill();
      //clearTimeout(this.slideTimer);
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate(winW, winH) {

    // キービジュアルエリアのサイズ設定
    if (this.isPC) {
      // 動画を表示領域いっぱいに表示する
      const imgW = 16;
      const imgH = 9;

      const scale = Math.min(imgW / winW, imgH / winH);

      const frameW = imgW / scale;
      const frameH = imgH / scale;
      const frameX = (winW - frameW) / 2;
      const frameY = (winH - frameH) / 2;

      //TweenMax.set(this.video, {position: 'absolute', left: frameX, top: frameY, width: frameW, height: frameH});
    } else {
      // スマホ版は横幅を見てリサイズをチェックする
      if (this.presentWidth != window.innerWidth) {
        // 画像を表示領域いっぱいに表示する
        this.slides.forEach((el, index) => {
          const ref = el.querySelector('img');
          const imgW = 750;
          const imgH = 1334;

          //const imgW = ref.naturalWidth;
          //const imgH = ref.naturalHeight;
          //if (!imgW) return true;

          const scale = Math.min(imgW / winW, imgH / winH);

          const frameW = imgW / scale;
          const frameH = imgH / scale;
          const frameX = (winW - frameW) / 2;
          const frameY = (winH - frameH) / 2;

          TweenMax.set(ref, {position: 'absolute', left: frameX, top: frameY, width: frameW, height: frameH});
        });
      }
    }

    this.presentWidth = window.innerWidth;
  }
}
